import { render, staticRenderFns } from "./AMMaster_new.vue?vue&type=template&id=0d264f42&scoped=true"
import script from "./AMMaster_new.vue?vue&type=script&lang=ts"
export * from "./AMMaster_new.vue?vue&type=script&lang=ts"
import style0 from "./AMMaster_new.vue?vue&type=style&index=0&id=0d264f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d264f42",
  null
  
)

export default component.exports